// Browser glue: load the logo and exceljs on demand, then hand the file to
// the user. Nothing is sent anywhere; the invoice is built in the browser.
import logoUrl from "./thread_logo.png";
import { buildInvoiceWorkbook } from "./workbook";
import { invoiceHtml } from "./printHtml";
import { invoiceFilename } from "./prefill";

async function logoBase64() {
  const buf = await (await fetch(logoUrl)).arrayBuffer();
  let s = ""; const bytes = new Uint8Array(buf);
  for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
  return btoa(s);
}

export async function downloadXlsx(cfg) {
  const [{ default: ExcelJS }, logo] = await Promise.all([import("exceljs"), logoBase64()]);
  const { wb } = buildInvoiceWorkbook(ExcelJS, cfg, logo);
  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = invoiceFilename(cfg);
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

// Opens the print view in a new tab and starts the print dialog there;
// choose "Save as PDF". The tab keeps the invoice if the dialog is closed.
export async function openPrintView(cfg) {
  const w = window.open("", "_blank");
  if (!w) throw new Error("The browser blocked the print window. Allow pop-ups for this site and try again.");
  const logo = `data:image/png;base64,${await logoBase64()}`;
  w.document.open();
  w.document.write(invoiceHtml(cfg, logo));
  w.document.close();
  const go = () => { w.focus(); w.print(); };
  if (w.document.fonts && w.document.fonts.ready) w.document.fonts.ready.then(() => setTimeout(go, 150)); else setTimeout(go, 400);
}
